// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sv_x","toggle":"styles_toggle__2VY1X","preview":"styles_preview__3wzJa"};